module.exports = __webpack_public_path__ + "static/img/carousel-4new.015cc56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/home/carousel-4new.jpg
// module id = 8zpz
// module chunks = 15